export default __webpack_public_path__ + "static/media/io.77d769c2.png";